/* THE VAULT — vault.js */
(function(){
'use strict';

// HEADER SCROLL
var hdr=document.getElementById('hdr');
if(hdr)window.addEventListener('scroll',function(){hdr.classList.toggle('scrolled',window.scrollY>40)},{passive:true});

// SEARCH
var sb=document.getElementById('srch-btn'),bar=document.getElementById('srch-bar');
if(sb&&bar){
  sb.addEventListener('click',function(){bar.classList.toggle('open');if(bar.classList.contains('open'))bar.querySelector('input').focus();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')bar.classList.remove('open');});
}

// DRAWER
var hbg=document.getElementById('hbg'),drw=document.getElementById('drw'),ovl=document.getElementById('ovl'),dc=document.getElementById('drw-cls');
function openD(){if(!drw)return;drw.classList.add('open');ovl.classList.add('on');hbg.classList.add('open');document.body.style.overflow='hidden';}
function closeD(){if(!drw)return;drw.classList.remove('open');ovl.classList.remove('on');hbg.classList.remove('open');document.body.style.overflow='';}
if(hbg)hbg.addEventListener('click',openD);
if(dc)dc.addEventListener('click',closeD);
if(ovl)ovl.addEventListener('click',closeD);

// PARTICLES
var canvas=document.getElementById('particles');
if(canvas){
  var ctx=canvas.getContext('2d'),pts=[],raf;
  function rsz(){canvas.width=window.innerWidth;canvas.height=window.innerHeight;}
  function mkp(){return{x:Math.random()*canvas.width,y:Math.random()*canvas.height,r:Math.random()*1.2+.3,vx:(Math.random()-.5)*.25,vy:-(Math.random()*.35+.08),o:Math.random()*.45+.08,g:Math.random()>.55};}
  function init(){rsz();pts=[];for(var i=0;i<70;i++)pts.push(mkp());}
  function draw(){
    ctx.clearRect(0,0,canvas.width,canvas.height);
    for(var i=0;i<pts.length;i++){
      var p=pts[i];p.x+=p.vx;p.y+=p.vy;
      if(p.y<-4||p.x<-4||p.x>canvas.width+4){pts[i]=mkp();pts[i].y=canvas.height+4;}
      ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
      ctx.fillStyle=p.g?'rgba(201,168,76,'+p.o+')':'rgba(255,255,255,'+(p.o*.35)+')';
      ctx.fill();
    }
    raf=requestAnimationFrame(draw);
  }
  init();draw();
  window.addEventListener('resize',init,{passive:true});
}

// REVEAL ON SCROLL
var rvs=document.querySelectorAll('.rv');
if(rvs.length&&'IntersectionObserver'in window){
  var ro=new IntersectionObserver(function(entries){
    entries.forEach(function(e,i){if(e.isIntersecting){setTimeout(function(){e.target.classList.add('on');},i*70);ro.unobserve(e.target);}});
  },{threshold:.1});
  rvs.forEach(function(el){ro.observe(el);});
}

// GALLERY THUMBS
var thumbs=document.querySelectorAll('.gal-thumb'),mimg=document.querySelector('.gal-main img');
if(thumbs.length&&mimg){
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      thumbs.forEach(function(x){x.classList.remove('active');});
      t.classList.add('active');
      var s=t.querySelector('img')&&t.querySelector('img').src;
      if(s){mimg.style.opacity='0';setTimeout(function(){mimg.src=s;mimg.style.opacity='1';},180);mimg.style.transition='opacity .18s';}
    });
  });
}

// QTY
document.querySelectorAll('.qty-b').forEach(function(b){
  b.addEventListener('click',function(){
    var inp=b.closest('.qty-w')&&b.closest('.qty-w').querySelector('.qty-i');
    if(!inp)return;
    var v=parseInt(inp.value)||1;
    inp.value=b.dataset.d==='+'?Math.min(v+1,99):Math.max(v-1,1);
  });
});

// CART COUNT
function updCC(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
    var b=document.querySelector('.cc');
    if(c.item_count>0){
      if(b){b.textContent=c.item_count;}
      else{var cb=document.querySelector('.ibtn[aria-label="Cart"]');if(cb){var s=document.createElement('span');s.className='cc';s.textContent=c.item_count;cb.appendChild(s);}}
    }
  }).catch(function(){});
}

// ADD TO CART
function addCart(vid,qty,btn){
  if(!vid)return;
  var orig=btn?btn.textContent:'';
  if(btn){btn.textContent='Adding...';btn.disabled=true;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:qty||1})})
  .then(function(r){if(!r.ok)throw new Error();if(btn)btn.textContent='✓ Added!';updCC();setTimeout(function(){if(btn){btn.textContent=orig;btn.disabled=false;}},2000);})
  .catch(function(){if(btn){btn.textContent='Try Again';btn.disabled=false;}});
}

document.querySelectorAll('.atc').forEach(function(b){
  b.addEventListener('click',function(e){
    e.preventDefault();
    var q=document.querySelector('.qty-i');
    addCart(b.dataset.vid,q?parseInt(q.value)||1:1,b);
  });
});

document.querySelectorAll('.qadd').forEach(function(b){
  b.addEventListener('click',function(e){
    e.preventDefault();e.stopPropagation();
    addCart(b.dataset.vid,1,b);
  });
});

// OPT BUTTONS
document.querySelectorAll('.opt-vals').forEach(function(g){
  g.querySelectorAll('.opt-btn').forEach(function(b){
    b.addEventListener('click',function(){
      g.querySelectorAll('.opt-btn').forEach(function(x){x.classList.remove('active');});
      b.classList.add('active');
    });
  });
});

// TICKER CLONE
var tt=document.querySelector('.ticker-t');
if(tt)tt.insertAdjacentHTML('beforeend',tt.innerHTML);

// CART PAGE UPDATE
window.updCI=function(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
  .then(function(){window.location.reload();}).catch(function(){});
};

})();
